$(window).on("load",function(){
	$("body").removeClass("preload");
});
$(function(){

	var body = $('body');

	//SVGスプライト
	$.ajax({
		type: 'get',
		url: '/wp/wp-content/themes/nishitan/assets/svg/icons.svg'//ここにパスを入れる（環境に合わせて変更）
	}).done(function(data) {
		var svg = $(data).find('svg');
		body.prepend(svg);
	});

	//スクロールアニメーション
	$('.animate').scrolla({
		mobile: true, // モバイルの有効・無効
		once: true, // 発火は１度だけか、視界に入るたびに発火させるか
		animateCssVersion: 4 // used animate.css version (3 or 4)
	});

	//ページ内スクロール
	$.smooziee();

	//スクロールしたらクラスを付与
	$(window).scroll(function () {
		if ($(this).scrollTop() > 160) {
			body.addClass("scroll");
		} else {
			body.removeClass("scroll");
		}
	});

	//スクロール上下でクラスを付与
	var beforePos = 0;//スクロールの値の比較用の設定
	function ScrollAnime() {
		var elemTop = 100
		// var elemTop = $('#area-2').offset().top;//#area-2の位置まできたら
		var scroll = $(window).scrollTop();
		//ヘッダーの出し入れをする
		if(elemTop > scroll || 0 > scroll - beforePos){
			body.addClass("scroll_up");
			body.removeClass('scroll_down');
		}else {
			body.addClass("scroll_down");
			body.removeClass('scroll_up');
		}
		beforePos = scroll;//現在のスクロール値を比較用のbeforePosに格納
	}
	// 画面をスクロールをしたら動かしたい場合の記述
	$(window).on('scroll', function(){
		ScrollAnime();
	});
	// ページが読み込まれたらすぐに動かしたい場合の記述
	$(window).on('load', function () {
		ScrollAnime();
	});

	//グロナビ開閉
	$('.header_menu_btn').on('click', function () {
		body.toggleClass('menu_open');
		return false;
	});

	$('.header_menu_content a').on('click', function () {
		body.removeClass('menu_open');
		// return false;
	});

    //閉じるボタン
    $('.header_menu_close').on('click', function () {
        body.removeClass('menu_open');
    });

    //メニュー名以外の部分をクリックで閉じる
    // $('.layer').on('click', function () {
    //     body.removeClass('menu_open');
    //     // body.removeClass('search_open');
    // });

	//アコーディオン
	$('.ac_trigger').on('click', function () {
		if($(this).hasClass('open')){
			$(this).removeClass('open');
		} else {
			$(this).addClass('open');
		}
		$(this).next(".ac_content").slideToggle();
	});

	//アコーディオン閉じる
	$('.ac_close').on('click', function () {
		var ac_trigger = $(this).parent().prev(".ac_trigger");
		var ac_content = $(this).parent(".ac_content");
		if($(ac_trigger).hasClass('open')){
			$(ac_trigger).removeClass('open');
		} else {
			$(ac_trigger).addClass('open');
		}
		$(ac_content).slideUp();
	    // 移動先を0px上にずらす
	    var adjust = 100;
	    // スクロールの速度
	    var speed = 500; // ミリ秒
	    // 移動先を調整
	    var position = $(ac_trigger).offset().top - adjust;
	    // スムーススクロール
	    $('body,html').animate({scrollTop:position}, speed, 'swing');
	    return false;
	});

    // ページが読み込まれたときに、URLのハッシュを確認してアコーディオンを開く
    var hash = window.location.hash;
    if (hash) {
        // URLのハッシュが存在する場合、対応するアコーディオンを開く
        var targetAccordion = $(hash);
        var targetAccordionTrigger =  $(targetAccordion).parent();
        if (targetAccordionTrigger.hasClass('ac_trigger')) {
        	$(targetAccordionTrigger).next(".ac_content").slideDown();
        	$(targetAccordionTrigger).addClass('open');
        }
    }

	//アンカーでアコーディオンを開く
    $('a[href^="#"]').on('click', function(event) {
        // アンカー先の要素がアコーディオンである場合のみ処理を実行
        var href = $(this).attr('href');
        // アコーディオントリガー要素
        var ac_trigger =  $(href).parent();
        // console.log(href);
        if( $(ac_trigger).hasClass('ac_trigger') ) {
        	// console.log("hoge");
        	$(ac_trigger).next(".ac_content").slideDown();
        	$(ac_trigger).addClass('open');
        }
    });


	//よくあるご質問　アコーディオン
	$('.schema-faq-question').on('click', function () {
		if($(this).hasClass('open')){
			$(this).removeClass('open');
		} else {
			$(this).addClass('open');
		}
		$(this).next(".schema-faq-answer").slideToggle();
	});

	//選ばれる理由　アコーディオン
	$('.reason_trigger').on('click', function () {
		if($(this).hasClass('open')){
			$(this).removeClass('open');
			$(this).text('詳しく見る');
		} else {
			$(this).addClass('open');
			$(this).text('閉じる');
		}
		$(this).prev(".reason_content").slideToggle();
		// var reason_trigger = $(this);
		var reason_content = $(this).prev(".reason_content");
	    // 移動先を0px上にずらす
	    var adjust = 200;
	    // スクロールの速度
	    // var speed = 300; // ミリ秒
	    // 移動先を調整
	    var position = $(reason_content).offset().top - adjust;
	    // スムーススクロール
	    $('body,html').animate({scrollTop:position},'linear');
	    return false;
	});

	//動画ポップアップ
    // $('.modalVideoBtn').modalVideo({channel: 'youtube'});

	//スマホ・PCのみ
	$(window).on('load resize', function(){
	// $(window).on('load', function(){
		var w = $(window).width();
		if (w <= 768) {
			//スマホ時
		} else {
			//PC時
		}
	});

	//タブ切り替え
    $(".tab_label").on("click",function(){
		var $th = $(this).index();
		$(this).parent().find(".tab_label").removeClass("active");
		$(this).parents().next().find(".tab_panel").removeClass("active");
		$(this).addClass("active");
		$(this).parents().next().find(".tab_panel").eq($th).addClass("active");
	});

    //タブへダイレクトリンクの実装

    //リンクからハッシュを取得
    var tabHash = location.hash;
    // console.log(tabHash);
    tabHash = (tabHash.match(/^#tab_panel_\d+$/) || [])[0];
   	//リンクにハッシュが入っていればtabnameに格納
    if ($(tabHash).length) {
        var tabname = tabHash.slice(1);
    } else {
        var tabname = "tab_panel_01";
    }
    //コンテンツ非表示・タブを非アクティブ
    $(".tab_wrap .tab_label").removeClass("active");
    $(".tab_wrap .tab_panel").removeClass("active");
    //何番目のタブかを格納
    var tabno = $(".tab_wrap .tab_panel#" + tabname).index();
    //コンテンツ表示
    $(".tab_wrap .tab_panel").eq(tabno).addClass("active");
    //タブのアクティブ化
    $(".tab_wrap .tab_label").eq(tabno).addClass("active");

	// youtube modal
	$('.modalVideoBtn').modalVideo({channel: 'youtube'});

	//トップページのみ
	if($('.home').length){
	}

	//サブメニュー スクロール位置変更 スマホ時
	if($('.page_nav').length){
		const thisWidth = $(".page_nav .active").position().left;
		// console.log(thisWidth);
		const headerNavBox = $(".page_nav_wrap");
		headerNavBox.delay(1000).animate({scrollLeft: thisWidth});
	}

	//バナースライドショー
	const bnr_swiper = new Swiper('.bnr_swiper', {
        slidesPerView: 'auto',
        // centeredSlides: true,
        // pagination: {
        //     el: '.swiper-pagination',
        //     clickable: true, // クリック可能にする
        // },
        // navigation: {
        //     nextEl: '.swiper-button-next',
        //     prevEl: '.swiper-button-prev',
        // },
        // scrollbar: {
    	// 	el: '.swiper-scrollbar',
    	// 	draggable:true,
  		// },
        // breakpoints: {
        //     768: {
        //         spaceBetween: 20,
        //     }
        // },
    });

    // 部活ループスライドショー
    const club_swiper = new Swiper('.club_swiper', {
        loop: true,
        slidesPerView: 'auto',
        allowTouchMove: false, // スワイプ無効
        preventInteractionOnTransition: true, //クリックなどをしてもスライダーの停止を防ぐ
        speed: 20000,
        autoplay: {
            delay: 0,
        },
        spaceBetween:0,
        breakpoints: {
            // スライドの表示枚数：768px以上の場合
            768: {
                // spaceBetween:20,
            }
        },
    });

    // 画像（四角形）ループスライドショー
    const square_swiper = new Swiper('.square_swiper', {
        loop: true,
        slidesPerView: 'auto',
        allowTouchMove: false, // スワイプ無効
        preventInteractionOnTransition: true, //クリックなどをしてもスライダーの停止を防ぐ
        speed: 4000,
        autoplay: {
            delay: 0,
        },
        spaceBetween:0,
        breakpoints: {
            // スライドの表示枚数：768px以上の場合
            768: {
                // spaceBetween:20,
            }
        },
    });

    // 懸垂幕スライドショー
    const kensuimaku_swiper = new Swiper('.kensuimaku_swiper', {
        // loop: true,
        slidesPerView: 'auto',
        // allowTouchMove: false, // スワイプ無効
        // preventInteractionOnTransition: true, //クリックなどをしてもスライダーの停止を防ぐ
        // speed: 2000,
        // autoplay: {
        //     delay: 2000,
        // },
        spaceBetween:9,
        pagination: {
            el: '.swiper-pagination',
            clickable: true, // クリック可能にする
        },
        breakpoints: {
            // スライドの表示枚数：768px以上の場合
            768: {
                // spaceBetween:20,
            }
        },
    });

    // 特色スライドショー
    const feature_swiper = new Swiper('.feature_swiper', {
        // loop: true,
        slidesPerView: 'auto',
        // allowTouchMove: false, // スワイプ無効
        // preventInteractionOnTransition: true, //クリックなどをしてもスライダーの停止を防ぐ
        // speed: 2000,
        // autoplay: {
        //     delay: 2000,
        // },
        // spaceBetween:9,
        pagination: {
            el: '.swiper-pagination',
            clickable: true, // クリック可能にする
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            // スライドの表示枚数：768px以上の場合
            768: {
                // spaceBetween:20,
            }
        },
    });

    // FAQスライドショー
    const faq_swiper = new Swiper('.faq_swiper', {
        // loop: true,
        slidesPerView: 'auto',
        // allowTouchMove: false, // スワイプ無効
        // preventInteractionOnTransition: true, //クリックなどをしてもスライダーの停止を防ぐ
        // speed: 2000,
        // autoplay: {
        //     delay: 2000,
        // },
        spaceBetween:20,
        centeredSlides: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true, // クリック可能にする
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            // スライドの表示枚数：768px以上の場合
            768: {
                centeredSlides: false,
                spaceBetween:0,
            }
        },
    });

    // メインビジュアルスライドショー
    const home_mv_swiper01 = new Swiper('.home_mv_swiper01 .swiper', {
    	effect: 'fade',
	  	fadeEffect: {
	    	crossFade: true
	  	},
        loop: true,
        slidesPerView: 'auto',
        allowTouchMove: false, // スワイプ無効
        preventInteractionOnTransition: true, //クリックなどをしてもスライダーの停止を防ぐ
        speed: 2000,
        autoplay: {
            delay: 2000,
        },
    });
    const home_mv_swiper02 = new Swiper('.home_mv_swiper02 .swiper', {
    	effect: 'fade',
	  	fadeEffect: {
	    	crossFade: true
	  	},
        loop: true,
        slidesPerView: 'auto',
        allowTouchMove: false, // スワイプ無効
        preventInteractionOnTransition: true, //クリックなどをしてもスライダーの停止を防ぐ
        speed: 2000,
        autoplay: {
            delay: 2100,
        },
    });
    const home_mv_swiper03 = new Swiper('.home_mv_swiper03 .swiper', {
    	effect: 'fade',
	  	fadeEffect: {
	    	crossFade: true
	  	},
        loop: true,
        slidesPerView: 'auto',
        allowTouchMove: false, // スワイプ無効
        preventInteractionOnTransition: true, //クリックなどをしてもスライダーの停止を防ぐ
        speed: 2000,
        autoplay: {
            delay: 2200,
        },
    });
    const home_mv_swiper04 = new Swiper('.home_mv_swiper04 .swiper', {
    	effect: 'fade',
	  	fadeEffect: {
	    	crossFade: true
	  	},
        loop: true,
        slidesPerView: 'auto',
        allowTouchMove: false, // スワイプ無効
        preventInteractionOnTransition: true, //クリックなどをしてもスライダーの停止を防ぐ
        speed: 2000,
        autoplay: {
            delay: 2300,
        },
    });
    const home_mv_swiper05 = new Swiper('.home_mv_swiper05 .swiper', {
    	effect: 'fade',
	  	fadeEffect: {
	    	crossFade: true
	  	},
        loop: true,
        slidesPerView: 'auto',
        allowTouchMove: false, // スワイプ無効
        preventInteractionOnTransition: true, //クリックなどをしてもスライダーの停止を防ぐ
        speed: 2000,
        autoplay: {
            delay: 2400,
        },
    });

});